import { render } from "./k-table-skeleton.vue?vue&type=template&id=30ae2ecc&scoped=true"
import script from "./k-table-skeleton.vue?vue&type=script&lang=js"
export * from "./k-table-skeleton.vue?vue&type=script&lang=js"

import "./k-table-skeleton.vue?vue&type=style&index=0&id=30ae2ecc&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../Users/martijn/Documents/GitHub/dfm/DFM-admin-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30ae2ecc"]])

export default __exports__